var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"create-limited-subscription-sidebar"},[_c('select-input',{staticClass:"mt-0",attrs:{"setup":{
      'func': _vm.setTarget,
      'args': {
        'model': _vm.node.data,
        'key': 'target',
        'options': _vm.targets,
        'clearable': false,
        'prefix': 'create_limited_subscription_',
      }
    }}}),(_vm.currentChannel)?_c('a-alert',[_c('a-spin',{attrs:{"slot":"message","spinning":_vm.loadChannelType},slot:"message"},[_c('channel-subscription-info',{attrs:{"channel-id":_vm.currentChannel.id,"channel-title":_vm.currentChannel.title,"channel-subscription-type":_vm.channelType,"get-channel-subscription-link":_vm.node.nodeProps.getChannelSubscriptionLink}})],1)],1):_vm._e(),_c('time-unit-input',{attrs:{"setup":{
      'func': _vm.setOffset,
      'args': {
        'model': _vm.node.data,
        'key': 'offset',
        'prefix': 'create_limited_subscription_',
        'min': Number.MIN_SAFE_INTEGER
      }
    }}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }